import "./style.scss";

export default function Load () {
  return (
    <div id="loading" className="vs-loading">
      <div className="spinner-grow text-dark" role="status"></div>
      <span className="ms-1">Aguarde...</span>
    </div>
  );
}